export default __webpack_public_path__ + "static/media/calendar.59dc9ff8.svg";